import { isCapacitor } from './isCapacitor'

/**
 * Safely imports Capacitor Stripe hooks to avoid module resolution errors
 */
export const useCapacitorStripe = () => {
  if (!isCapacitor) {
    return null
  }

  try {
    // Use dynamic import with error handling
    const CapacitorStripeModule = require('@capacitor-community/stripe')

    if (CapacitorStripeModule && CapacitorStripeModule.useCapacitorStripe) {
      return CapacitorStripeModule.useCapacitorStripe()
    }

    // Fallback to direct import if available
    const {
      useCapacitorStripe: hook,
    } = require('@capacitor-community/stripe/dist/esm/react/provider')
    return hook()
  } catch (error) {
    console.warn('Capacitor Stripe not available:', error.message)
    return null
  }
}

/**
 * Safely imports Capacitor Stripe provider to avoid module resolution errors
 */
export const CapacitorStripeProvider = ({ children, ...props }) => {
  if (!isCapacitor) {
    return children
  }

  try {
    // Use dynamic import with error handling
    const CapacitorStripeModule = require('@capacitor-community/stripe')

    if (
      CapacitorStripeModule &&
      CapacitorStripeModule.CapacitorStripeProvider
    ) {
      const { CapacitorStripeProvider: Provider } = CapacitorStripeModule
      return <Provider {...props}>{children}</Provider>
    }

    // Fallback to direct import if available
    const {
      CapacitorStripeProvider: Provider,
    } = require('@capacitor-community/stripe/dist/esm/react/provider')
    return <Provider {...props}>{children}</Provider>
  } catch (error) {
    console.warn('Capacitor Stripe Provider not available:', error.message)
    return children
  }
}
